import { AssessmentQuestionType, QuestionStandard } from '@models/score';
import { ProductType } from '@shared/enums/product-type';
import { ScoreBenchmark } from '@shared/enums/score-benchmark';
import { VariantType } from '@shared/enums/variant-type';

export interface StudentOverTimeReportRequest {
  productType: ProductType;
  grade: VariantType;
  userId: string;
}

export enum AssessmentStatus {
  NotStarted = 'NOT STARTED',
  Completed = 'COMPLETED',
  InProgress = 'TEST IS CURRENTLY IN PROGRESS',
  AddScore = 'ADD SCORE',
  PartiallyScored = 'PARTIALLY SCORED',
  ScoringInProgress = 'SCORING IN PROGRESS',
  ScoreNotAvailable = 'SCORE NOT AVAILABLE',
  ReadyForScoring = 'READY FOR SCORING',
}

export interface AssessmentAttempt {
  description: string;
  attempt: string[];
}

export interface StudentOverTimeReportQuestion extends QuestionStandard {
  questionKey?: string;
  questionNumber: number;
  correct: boolean;
  submittedOn?: string;
  prompt?: string;
  instructions?: string;
  correctValue?: string;
  answerChoices?: string[];
  attempts: AssessmentAttempt[];
  assessmentQuestionType?: string | AssessmentQuestionType;
  attemptLink?: string;
}

export interface StudentOverTimeReportScoreDetail {
  part?: string;
  description?: string;
  objective?: string;
  scoreIsOverridden: boolean;
  questions: StudentOverTimeReportQuestion[];
}

export interface StudentOverTimeBenchmarkResult {
  assessmentKey?: string;
  assessmentName?: string;
  unit: number;
  topicWeight: number;
  assessmentStatus?: AssessmentStatus;
  benchmark?: ScoreBenchmark;
  score?: string;
  scorePercentage: number;
  scoreIsOverridden: boolean;
  scoreDetail: StudentOverTimeReportScoreDetail;
  totalCorrect: number,
  totalQuestions: number,
  completedOn?: string;
  lastOverriddenUserName?: string;
  lastOverriddenOn?: string;
  wordListLevel?: string;
}

export interface StudentOverTimeReport {
  classroomId: string;
  productType: ProductType;
  grade: VariantType;
  firstName?: string;
  lastName?: string;
  userId?: string;
  benchmarkResults: StudentOverTimeBenchmarkResult[];
}
